import { render } from "./middleNumber.vue?vue&type=template&id=763b6964&scoped=true"
import script from "./middleNumber.vue?vue&type=script&lang=js"
export * from "./middleNumber.vue?vue&type=script&lang=js"

import "./middleNumber.vue?vue&type=style&index=0&id=763b6964&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-763b6964"

export default script